<template>
  <div v-if="!cancellationFormOptions">
    <LoadingState />
  </div>
  <div v-else-if="cancellationFormOptions">
    <h2>
      <span class="red">{{ $t("global.cancelling") }}:</span>
      {{ cancellationFormOptions.service.identity }}
    </h2>
    <p>{{ $t("global.effective-date") }}: {{ cancellationFormOptions.scheduled_date }}</p>
    <hr />
    <p>{{ $t("global.cancellation-add-blurb") }}</p>
    <hr />
    <CancellationForm
      :service-id="serviceId"
      :service-type="serviceType"
      :form-fields="cancellationFormOptions.form.fields"
      @success="redirect"
    />
  </div>
  <div v-else>
    <ErrorState />
  </div>
</template>

<script>
import CancellationForm from "@/components/smart/forms/CancellationForm";
import { canDelete } from "@/utils/useAuth";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import { ref } from "@vue/composition-api";
import store from "@/store";

export default {
  name: "CancellationDetail",
  props: {
    serviceId: Number,
    serviceType: String,
  },
  components: {
    CancellationForm,
    ErrorState,
    LoadingState,
  },
  setup(props, { root }) {
    const cancellationFormOptions = ref(null);
    const routeMap = {
      sharedHosts: "shared-hosting",
    };

    if (canDelete("services")) {
      store
        .dispatch(`${props.serviceType}/getCancellationFormOptions`, { id: props.serviceId })
        .then((options) => {
          cancellationFormOptions.value = options;
        })
        .catch(() => {
          store.dispatch("toasts/addToast", {
            variant: "error",
            message: root.$t("toasts.request-cancellation-error-message"),
          });
          redirect();
        });
    }

    const redirect = () => {
      store.dispatch(`${props.serviceType}/refreshList`);
      const routeName = routeMap[props.serviceType]
        ? routeMap[props.serviceType]
        : props.serviceType;
      root.$router.push({ name: routeName });
    };

    return {
      cancellationFormOptions,
      redirect,
    };
  },
};
</script>
